import React, { useState,useEffect } from 'react';
import { ApiHelper } from "../../helpers/ApiHelper";
import user from "../../assets/img/event/attending.svg"
import locations from "../../assets/img/event/map-pin.svg"
import utype from "../../assets/img/event/users.svg"
import phone from "../../assets/img/event/phone.svg"
import userq from "../../assets/img/event/user.svg"
import globe from "../../assets/img/event/globe.svg"
const About = (props) => {
  const [location, setLocation] = useState('');
     useEffect(() => {
          const fetchLocation = async () => {
              if (props.about.zipcode) {
                  const result = await getLocationFromZip(props.about.zipcode);
                  setLocation(result);
              }
          };
  
          fetchLocation();
      }, [props.about.zipcode])
   const getLocationFromZip = async (zipCode) => {
  
          const apiKey = process.env.REACT_APP_ZIP_API
          const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${zipCode}&key=${apiKey}`;
  
          try {
              const response = await ApiHelper.get(url);
  
              // 🔒 Prevent accessing undefined when results are empty
              if (!response.data.results || response.data.results.length === 0) {
                  console.warn('No results found for zip code:', zipCode);
                  return '';
              }
  
              const components = response.data.results[0].address_components || [];
  
              const getComponent = (type) =>
                  components.find((comp) => comp.types.includes(type))?.long_name || '';
  
              const streetNumber = getComponent('street_number');
              const route = getComponent('route');
              const city = getComponent('locality');
              const state = getComponent('administrative_area_level_1');
              const postalCode = getComponent('postal_code');
              const country = getComponent('country');
  
              const formattedAddress = `${city}, ${state}, ${country}`;
  
              return formattedAddress;
          } catch (error) {
              console.error('Geocoding API error:', error);
              return '';
          }
      };
    
  
 return (

    <div className="rightbar">

      <div className='about-content'>
        <h4 className='rightbar-heading' >About</h4>


        <ul className='p-0 m-0 org-detains-dh-right' >
          <li>
            <div className='org-features-dh'>
                  <img src={userq} alt="test" className="event-f-icon" />
                  <lable class="event-f-name">Contact Name</lable>
            </div>
             <span className='org-ans' ></span>
             <div className='event-time px-4'>
               <p>{props.about.contactName}</p>
             </div>
          </li>
           <li>
            <div className='org-features-dh'>
                  <img src={phone} alt="test" className="event-f-icon" />
                  <lable class="event-f-name">Phone</lable>
            </div>
             <div className='event-time px-4'>
               <p>{props.about.phoneNumber}</p>
             </div>
          </li>
           <li className='flex-column' >
            <div className='org-features-dh'>
                  <img src={globe} alt="test" className="event-f-icon" />
                  <lable class="event-f-name">Website</lable>
            </div>
             <div className='event-time px-4'>
               <p>
                {props.about.website}
               </p>
             </div>
          </li>
           <li>
            <div className='org-features-dh'>
                  <img src={utype} alt="test" className="event-f-icon" />
                  <lable class="event-f-name">MemberCount</lable>
            </div>
             <div className='event-time px-4'>
               <p> {props.about.membersCount}</p>
             </div>
          </li>
          
           
          
          <li>
            <div className='org-features-dh'>
                  <img src={locations} alt="test" className="event-f-icon" />
                  <lable class="event-f-name">Location</lable>
            </div>
             <div className='event-time px-4'>
               <p>
                {location}
               </p>
             </div>
          </li>
        </ul>
       
      </div>

    

    </div>

  );


};
export default About;